import { ApiException } from '../common/PricePrgClient';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessage(error: any) {
    let errorMsg: string;
    if (error instanceof ApiException) {
        errorMsg = getErrorMsg(error);
    } else if (error?.message) {
        errorMsg = error.message;
    } else {
        errorMsg = error;
    }

    return errorMsg?.replace('An unexpected server error occurred.', '');
}

function getErrorMsg(error: ApiException) {
    if (error.response == null) {
        return null;
    }

    if (error.status === 403) {
        return 'Error: Missing permission to perform this action.';
    }

    try {
        const json = JSON.parse(error.response);

        if (json.message) {
            return json.message;
        }
        if (json.errors) {
            return `${Object
                .entries(json.errors)
                .map(([key, val]) => `${key}: ${val}`)
                .join('')}`;
        }
    } catch (e) {
        const idx = error.response.indexOf(' at ');
        return `${error.message} ${idx !== -1 ? error.response.substr(0, idx) : error.response}`;
    }

    return null;
}
